import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-chat-typing',
    templateUrl: './chat-typing.component.html',
    styleUrls: ['./chat-typing.component.scss'],
    standalone: false
})
export class ChatTypingComponent {
  @Input() status$!: Observable<string>;
}
